/**
 * Voucher variant names used for campaign-based voucher selection.
 * These variants are used to map URL pref parameters to specific vouchers.
 *
 * Based on Gatsby implementation:
 * - packages/core/cms/helpers/pref/voucher.js
 */
export const VOUCHER_VARIANTS = {
  GOOGLE: 'google',
  BING: 'bing',
  CAMPAIGN_PARTNER: 'campaign_partner',
  OTHERS: 'others',
} as const;

/**
 * Type for voucher variant names
 */
export type VoucherVariant = (typeof VOUCHER_VARIANTS)[keyof typeof VOUCHER_VARIANTS];

/**
 * URL-based campaign parameters for campaign tracking and voucher selection.
 * Extracted from URL search parameters (p_ref and campaignId).
 */
export interface CampaignParams {
  /** Pref parameter from URL (e.g., 'cpc_gg_pid_kwd1882048492') */
  pref?: string;
  /** Campaign ID from URL (e.g., 58437274) */
  campaignId?: number;
}

/**
 * PSI service endpoint types for campaign email sending
 */
export type CampaignServiceEndpoint = 'email.send.downloadThx' | 'email.send.downloadThxWithPrefCheck';

/**
 * Campaign voucher configuration details.
 * Contains variant selection, email template ID, service endpoint, and voucher value.
 */
export interface CampaignVoucherDetails {
  /** Voucher variant name (google, bing, campaign_partner, others) */
  variant: VoucherVariant;
  /** Email template ID (215, 217, 251, 392) */
  emailId?: number;
  /** PSI service endpoint to call */
  serviceEndpoint?: CampaignServiceEndpoint;
  /** Voucher value (e.g., 15, 25, "20%", "30%") */
  voucherValue?: number | string;
}
